import React from 'react';
import PropTypes from 'prop-types';
import Notification from '~/components/Notification';

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
export default function NotificationSwitcher({
  currentKey,
  children,
  ...notificationProps
}) {
  const currentNotification = React.Children.toArray(children).find(
    child => child.props.name === currentKey
  );
  if (currentNotification) {
    return React.cloneElement(currentNotification, notificationProps);
  }
  return (
    <Notification {...notificationProps}>
      {notificationProps.description}
    </Notification>
  );
}

const propTypes = {
  children: PropTypes.node,
  currentKey: PropTypes.string
};

NotificationSwitcher.propTypes = propTypes;
